<template>
    <div :class="view_class_view.form_container">
        <div :class="view_class_view.input_container">
            <label class="font-normal" for="select_amount"> Monto: </label>
            <select name="select_amount" id="select_amount"
                v-model="creditDataModelValidations.amount.$model"
                v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]:  creditDataModelValidations.amount.$error,
                                [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:! creditDataModelValidations.amount.$invalid,
                                [view_class_view.class_inputs.default ]: creditDataModelValidations.amount.$invalid && ! creditDataModelValidations.amount.$error  }"
                @blur="creditDataModelValidations.amount.$validate" >
                <option v-for="(amount, index) in amount_list" :value="amount" :key="index"> {{ amount }}</option>
            </select>

            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of creditDataModelValidations.amount.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>

        <div :class="view_class_view.input_container">
            <ChooseButton
            :buttons="buttonsFrecuency"
            :flex="true"
            v-model="creditDataModelValidations.frecuency"
            v-on:choose-button="getValueChooseButtonFrecuency($event)"
            label="Periodicidad:"
            />
            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of creditDataModelValidations.frecuency.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>

        <div :class="view_class_view.input_container">
            <label class="font-normal" for="select_payment"> Plazo: </label>
            <select name="select_payment" id="select_payment"
                v-model="creditDataModelValidations.deadline.$model"
                v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]:  creditDataModelValidations.deadline.$error,
                                [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:! creditDataModelValidations.deadline.$invalid,
                                [view_class_view.class_inputs.default ]: creditDataModelValidations.deadline.$invalid && ! creditDataModelValidations.deadline.$error  }"
                @blur="creditDataModelValidations.deadline.$validate" >
                <option v-for="(deadline, index) in deadline_list" :value="deadline" :key="index"> {{ deadline }}</option>
            </select>
            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of creditDataModelValidations.deadline.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>
        
        <div :class="view_class_view.input_container">
            <label class="font-normal" for="select_destination_of_credit"> Destino del crédito: </label>
            <select name="select_destination_of_credit" id="select_destination_of_credit" 
                v-model="creditDataModelValidations.credit_destination.$model"
                v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]:  creditDataModelValidations.credit_destination.$error,
                                [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:! creditDataModelValidations.credit_destination.$invalid,
                                [view_class_view.class_inputs.default ]: creditDataModelValidations.credit_destination.$invalid && ! creditDataModelValidations.credit_destination.$error  }"
                @blur="creditDataModelValidations.credit_destination.$validate" >
                <option v-for="(credit_destination, index) in credit_destination_list" :value="credit_destination" :key="index"> {{ credit_destination }}</option>
            </select>
            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of creditDataModelValidations.credit_destination.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>

        <div :class="view_class_view.input_container">
            <label class="font-normal" for="select_method_of_payment"> Método de pago: </label>
            <select name="select_method_of_payment" id="select_method_of_payment" 
                v-model="creditDataModelValidations.payment_method.$model"
                v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]:  creditDataModelValidations.payment_method.$error,
                                [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:! creditDataModelValidations.payment_method.$invalid,
                                [view_class_view.class_inputs.default ]: creditDataModelValidations.payment_method.$invalid && ! creditDataModelValidations.payment_method.$error  }"
                @blur="creditDataModelValidations.payment_method.$validate" >
                <option v-for="(payment_method, index) in payment_method_list" :value="payment_method" :key="index"> {{ payment_method }}</option>
            </select>
            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of creditDataModelValidations.payment_method.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div> 
        </div>

    </div>
</template>

<script>
import { ref } from 'vue';
import useVuelidate from "@vuelidate/core";
import ChooseButton from "./Forms/ChooseButton.vue";
export default {
    name: 'CreditData',
    props: {
        validations: {
            type: Object,
            default(){
                return {};
            }
        },
        view_class_view: {
            type: Object,
            default(){
                return {};
            }
        },
        amount_list: {
            type: Array,
            default(){
                return [];
            }
        },
        deadline_list: {
            type: Array,
            default(){
                return [];
            }
        },
        credit_destination_list: {
            type: Array,
            default(){
                return [];
            }
        },
        payment_method_list: {
            type: Array,
            default(){
                return [];
            }
        }
    },
    setup(props){
        const buttonsFrecuency = ref([
            { id: "button_periodicity_fortnightly", value: "quincenal", text: "Quincenal" },
            { id: "button_periodicity_monthly", value: "mensual", text: "Mensual" }
        ]);

        let creditDataModel = ref( { amount: "", frecuency: "", deadline: "", credit_destination: "", payment_method: ""} );
        let creditDataModelValidations = useVuelidate(props.validations, creditDataModel);

        function getValueChooseButtonFrecuency(value){
            creditDataModelValidations.value.frecuency.$model = value;
        }

        function execute_validation(){
            creditDataModelValidations.value.$validate();
            if(creditDataModelValidations.value.$error){
                return false;
            }
            return creditDataModel.value;
        }

        return {
            buttonsFrecuency,
            creditDataModel,
            creditDataModelValidations,
            getValueChooseButtonFrecuency,
            execute_validation
        };
    },
    components: {
        ChooseButton
    }
}

</script>

<style scoped>
label {
    color: #485462;
}
</style>

<style>
p.label-input {
    color: #485462;
    font-weight: 400;
}
</style>